import React from 'react'
import { graphql } from 'gatsby'
import SEO from '~/components/seo'
import axios from 'axios'
import '../../styles/contact-page.css'

class ContactPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showNotification: false,
      showError: false,
    }
  }

  sendMail = e => {
    e.preventDefault()
    const { fullName, email, subject, message, checked } = e.target

    const form = {
      name: fullName.value,
      email: email.value,
      subject: subject.value,
      message: message.value,
      checked: checked.checked,
    }

    axios
      .post(`/.netlify/functions/contact`, form)
      .then(res => {
        this.setState({
          showNotification: true,
          notification: this.props.data.pageData.frontmatter.subscriptionSuccess,
        })
      })
      .catch(err => {
        this.setState({
          showError: true,
          error: 'Something went wrong! Please contact general@nsjpa.com if the error persists.',
        })
        console.log(err)
      })
    e.target.reset()
  }

  render() {
    const { notification, showError, error, showNotification } = this.state
    const {
      data: {
        pageData: {
          frontmatter: { seo_title, seo_description, title, subscribeText, subscriptionSuccess },
        },
      },
    } = this.props

    return (
      <>
        <SEO title={seo_title} description={seo_description} />
        <div className="page-layout contact-page pulsatingAnimation">
          <div className="contact-form-container">
            {showError && <p className="error-message">{error}</p>}
            {!showNotification ? (
              <>
                <h1 className="contact-title">{title}</h1>
                <form className="contact-form" onSubmit={this.sendMail}>
                  <input type="text" name="fullName" className="contact-input" placeholder="YOUR NAME" required />
                  <input
                    type="email"
                    name="email"
                    className="contact-input"
                    placeholder="YOUR EMAIL ADDRESS"
                    required
                  />
                  <div className="select-container">
                    {/* comments */}
                    <label>
                      <select className="contact-select" name="subject" required>
                        <option disabled selected>
                          REASON FOR CONTACT
                        </option>
                        <option>GENERAL INQUIRIES</option>
                        <option>MURAL SERVICES</option>
                        <option>PROJECT COMMISSIONS</option>
                        <option>OBTAIN PRICE LIST</option>
                      </select>
                    </label>
                  </div>
                  <textarea name="message" className="contact-message" placeholder="TYPE MESSAGE HERE..." required />
                  <div className="newsletter-question">
                    <span className="checkbox-text">{subscribeText}</span>
                    <label className="custom-checkbox-container">
                      <input type="checkbox" name="checked" />
                      <span className="custom-checkmark" />
                    </label>
                  </div>

                  <button className="contact-button">SEND</button>
                </form>
              </>
            ) : (
              notification && (
                <div className="submittedMessage">
                  <h2 className="fadeIn notification-message">{notification}</h2>
                </div>
              )
            )}
          </div>
        </div>
      </>
    )
  }
}

export const query = graphql`
  query($slug: String) {
    pageData: markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        seo_title
        seo_description
        title
        subscribeText
        subscriptionSuccess
      }
    }
  }
`

export default ContactPage
